import React, { Fragment } from "react";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Pagination, Autoplay]);
import type { NextPage } from "next";
import Image from "next/image";
import Layout from "../layout/layout";
import csr1 from "../assets/images/csr/2.png";
import csr2 from "../assets/images/csr/1.png";
import csr3 from "../assets/images/csr/3.png";
import csr4 from "../assets/images/csr/4.png";
import csr5 from "../assets/images/csr/5.png";
import csr6 from "../assets/images/csr/6.png";
import banner from "../assets/images/crs-banner.jpeg";
import health1 from "../assets/images/health_1.jpg";
import health2 from "../assets/images/health_2.jpg";
import health3 from "../assets/images/health_3.jpg";
import health4 from "../assets/images/health_4.jpg";
import health5 from "../assets/images/health_5.jpg";
import health6 from "../assets/images/health_6.jpg";
import health7 from "../assets/images/health_7.jpg";
import edu1 from "../assets/images/edu_1.jpg";
import edu2 from "../assets/images/edu_2.jpg";
import edu3 from "../assets/images/edu_3.jpg";
import edu4 from "../assets/images/edu_4.jpg";
import kishalya1 from "../assets/images/kisalaya.jpeg";
import kishalya3 from "../assets/images/kishalya3.jpg";
import greenflame1 from "../assets/images/greenflame1.jpg";
import shivsway1 from "../assets/images/SHIVSWAY1.jpg";
import shivsway2 from "../assets/images/SHIVSWAY2.jpg";
import arrow from "../assets/images/arow-ri.png";

import styles from "../styles/csr.module.scss";

const Csr: NextPage = () => {
  return (
    <Layout>
      <div className={styles.csr_banner}>
        <Image
          src={banner}
          alt="P. C. Sen Charitable Trust - Senco Gold and Diamonds"
          width={2313}
          height={923}
        />
      </div>
      <div className={styles.health_services}>
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <div className={`${styles.health_services_image} ${"pe-md-3"}`}>
                <Swiper
                  className="swiper-navigation"
                  navigation={true}
                  spaceBetween={0}
                  slidesPerView={1}
                  centeredSlides={true}
                  autoplay={{
                    delay: 9000,
                    disableOnInteraction: false,
                  }}
                >
                  <SwiperSlide>
                    <Image src={health1} alt="image" width={570} height={400} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={health2} alt="image" width={570} height={400} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={health3} alt="image" width={570} height={400} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={health4} alt="image" width={570} height={400} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={health5} alt="image" width={570} height={400} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={health6} alt="image" width={570} height={400} />
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={health7} alt="image" width={570} height={400} />
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
            <div className="col-md-7">
              <div className={styles.head_sec_csr}>Health Service wing:</div>
              <p className={styles.left_border}>
                Late Shankar Sen was Managing Director of Senco Gold &amp;
                Diamonds Ltd and Vice Chairman of All India Gem and Jewellery
                Council. He was a generous and visionary personality who
                departed for heavenly abode in 2020. Late Sen envisioned through
                his holistic philosophy two prime necessities for the society –
                (a) healthy life style and (b) job oriented Skill Development
                support to rural population of South 24 Parganas.
              </p>
              <p>
                P C Sen Charitable Trust for the purpose, purchased huge land to
                build a health facility inclusive of a general hospital and a
                nursing academy. In addition he had two more plans – (a) to
                set-up an outstanding Paramedical Institute to provide technical
                academic support to the youths to be self-assured and (b) a home
                for old aged persons.
              </p>
              <p>
                His sole aim was to broaden the whole community where all people
                can easily reach to health and education to be healthy and
                youths to become self-dependent.
              </p>
            </div>
          </div>
        </div>
      </div>
      <section>
        <div className={styles.health_services}>
          <div className="container">
            <div className="row">
              <div className="col-md-7">
                <div className={styles.head_sec_csr}>Educational wing:</div>
                <p className={styles.left_border}>
                  Shaankar Sen Institute For Vocational Studies For Women &amp;
                  Youth (Shivsway) ( SHIVSWAY) is laid on the foundation of
                  philanthropic principal of Former Chairman&amp; Managing
                  Director of Senco Gold &amp; Diamonds , Mr. Shaankar Sen.
                  SHIVSWAY since its inception is pledged to build an inclusive
                  eco-system of vocational studies that could transform the
                  lives of thousand of youth &amp; women by harnessing their
                  potential for a rewarding career in emerging Retail and other
                  industries.
                </p>
                <p>
                  Being guided by the insight &amp; Vision of , Late Shaankar
                  Sen and accelerated by the vigour &amp; enthusiasm of our
                  present MD &amp; CEO , Mr. Shuvankar Sen, SHIVSWSY
                  relentlessly work towards fulfilling our collective commitment
                  towards the society at large by creating sustainable
                  livelihood opportunities for all through Skill development and
                  capacity building exercise. The path breaking initiatives
                  aided &amp; supported by Senco Group in the genre of Corporate
                  Social Responsibility is propelled by the liberating thoughts
                  to create an inclusive society where everyone will have
                  seamless access to upskilling &amp; reskilling opportunities
                  and therefore will be provided with a level playing field to
                  join skilled workforce, grow, prosper and can eventually forge
                  a blissful life and career for themselves.Closely knitted to
                  the cause of Social welfare by making everyone capable of
                  living a life of dignity on the merit of their own skills and
                  abilities.
                </p>
                <p>
                  We have also entered into a collaboration with Technical
                  Education Dept. Of Govt Of West-Bengal and has emerged as an
                  Associate Training partner with Paschim Banga Society For
                  Skill Development (PBSSD) in their Utkarsh Bangla Project.
                </p>
                <p>
                  Presently we are pursuing two different training program under
                  Gems &amp; Jewellery Sector Skill Council at our Baguiati
                  Centre. The details of the training are as follow.
                </p>
              </div>
              <div className="col-md-5">
                <div className={`${styles.health_services_image} ${"pe-md-3"}`}>
                  <Swiper
                    className="swiper-navigation"
                    navigation={true}
                    spaceBetween={0}
                    slidesPerView={1}
                    centeredSlides={true}
                    autoplay={{
                      delay: 9000,
                      disableOnInteraction: false,
                    }}
                  >
                    <SwiperSlide>
                      <Image src={edu1} width={570} height={750} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <Image src={edu2} width={570} height={750} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <Image src={edu3} width={570} height={750} alt="" />
                    </SwiperSlide>
                    <SwiperSlide>
                      <Image src={edu4} width={570} height={750} alt="" />
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div
          className={styles.cad_design}
          //   style="
          //   background-image: url('https://sencogold.com/template/images/csr_bg.png');
          // "
        >
          <div className="container">
            <div className={styles.bg_white_trans}>
              <div className={styles.head_dark}>
                Jewellery Retail Sales Training
              </div>
              <p>
                <strong className={styles.text_red}>Training Outcome:</strong>
              </p>
              <p>
                Get students groomed & coached on the skill-set requirements
                recommended for Counter Sales Executive or Retail Sales
                Associate profile. Also implant the elements of confidence
                building , Corporate etiquette & personality development in them
                so as to help them emerge as someone who is capable of handing
                customer queries effectively, build a sustainable relationship
                with customers and can eventually ensure a favorable shopping
                experience for all who walk-into a Retail store.
              </p>

              <p>
                <strong className={styles.text_red}>
                  Training Pre-requisite:
                </strong>
              </p>
              <p>
                Students require a cheerful disposition equipped with a pleasing
                personality & an inherent ability to engage, influence &
                persuade others always stand suitable for the training. Those
                who are performance driven & have the confidence & perseverance
                to achieve organizational goals consistently will also have an
                edge over others in this genre of training.
              </p>

              {/* <p><strong className="text-red">Training USP : </strong></p>
            <ul>
              <li>
                <span>
                  This is a FREE training therefore no cost involved with the
                  pursuance of the training.
                </span>
              </li>
              <li>
                <span>
                  Most advanced curriculum curated by the Best Of the Minds from
                  the jewellery Sector Skill Council Of India
                </span>
              </li>
              <li>
                <span>
                  State of Art digital infrastructure with seamless exposure to
                  latest designing softwares
                </span>
              </li>
              <li>
                <span>
                  Hands on Practical Training with exposure to the Biggest
                  Jewellery workshop of Kolkata
                </span>
              </li>
              <li>
                <span>
                  Extensive training in all the genres of Costume, Junk and
                  Bridal jewellery.
                </span>
              </li>
              <li>
                <span>
                  Customized support for individual portfolio and Project work.
                </span>
              </li>
              <li>
                <span>
                  360 Degree Placement assistance for most desirable design jobs
                  in the town
                </span>
              </li>
              <li>
                <span>
                  Govt Affiliated and industry endorsed certification on
                  successful completion of the training.
                </span>
              </li>
            </ul>  */}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className={styles.jewellery_retail}>
          <div className="container">
            <div className={`${styles.header_center} ${"mb-4"}`}>
              CSR Education Projects
            </div>
            <div className="row">
              <div className="col-md-8">
                <div
                  className={`${styles.jewellery_retail_card} ${"bg-white"}`}
                >
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className={styles.jewellery_retail_images}>
                        <Image
                          src={kishalya1}
                          width={424}
                          height={395}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={`${
                          styles.card_body_text
                        } ${"p-3"} ${"p-md-0"}`}
                      >
                        <div className={styles.jewellery_sec}>KISHALAYA</div>
                        <p className={styles.p_text}>
                          Our humble support to underprivileged students in
                          pursuing their basic education, either by extending
                          one time or monthly financial support, or by donating
                          educational kits and support system.
                        </p>
                      </div>
                      <a href="kishalaya" className={styles.arrow_more}>
                        <Image src={arrow} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className={styles.jewellery_retail_image}>
                  <Image src={kishalya3} width={424} height={395} alt="" />
                </div>
              </div>
              <div className="col-md-4">
                <div
                  className={`${styles.jewellery_retail_images_text} ${"p-3"}`}
                >
                  <div className={styles.jewellery_sec}>
                    SENCO GOLD AND DIAMONDS CSR INITIATIVES FOR CREATING LESS
                    POLUTING RURAL KITCHEN
                  </div>
                  <a href="greenflame" className={styles.arrow_more}>
                    <Image src={arrow} alt="" />
                  </a>
                </div>
              </div>
              <div className="col-md-8">
                <div
                  className={`${styles.jewellery_retail_card} ${"bg-white"}`}
                >
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className={styles.jewellery_retail_images}>
                        <Image
                          src={greenflame1}
                          width={424}
                          height={395}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={`${
                          styles.card_body_text
                        } ${"p-3"} ${"p-md-0"}`}
                      >
                        <div className={styles.jewellery_sec}>GREEN FLAME</div>
                        <p className={styles.p_text}>
                          The concept of Eco-Friendly Domestic or Community
                          Chula has been designed by one of our beneficiary NGO,
                          Alinan Ramakrishna Vivekananda Yuva Sangha, which has
                          overall thermal efficiency of 23.08% and overall power
                          rating of 1.33KW, and has been certified by School of
                          Energy Studies, Jadavpur University. We have already
                          installed 350 Improved Domestic Chullah at villages in
                          districts of West Bengal, there by helping our Rural
                          underprivileged women to have less polluting kitchen..
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-8">
                <div
                  className={`${styles.jewellery_retail_card} ${"bg-white"}`}
                >
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className={styles.jewellery_retail_images}>
                        <Image
                          src={shivsway1}
                          width={424}
                          height={395}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={`${
                          styles.card_body_text
                        } ${"p-3"} ${"p-md-0"}`}
                      >
                        <div className={styles.jewellery_sec}>SHIVSWAY</div>
                        <p className={styles.p_text}>
                          Gainful employment is the only way to empowerment. The
                          ShivSway Shaankar Sen Institute for Vocational Studies
                          for Women &amp; Youth was created with a vision to
                          empower and inspire marginalised youth.
                        </p>
                      </div>
                      <a href="shivsway" className={styles.arrow_more}>
                        <Image src={arrow} alt="" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className={styles.jewellery_retail_image}>
                  <Image src={shivsway2} width={424} height={395} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className={styles.video_container}>
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <iframe
                  width="100%"
                  height="280"
                  src="https://www.youtube.com/embed/sx-qYzDSVhc"
                  title="Project Green Flame | PC SEN CHARITABLE TRUST"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="col-md-4">
                <iframe
                  width="100%"
                  height="280"
                  src="https://www.youtube.com/embed/XKrTvLpydkM"
                  title="Project Kishalaya | PC SEN CHARITABLE TRUST"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="col-md-4">
                <iframe
                  width="100%"
                  height="280px"
                  src="https://www.youtube.com/embed/db8ZsxXm3GQ"
                  title="Prabhat Diagnostic | A Unit of P C Sen Charitable Trust | Supported by Senco Gold Limited"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Csr;
